<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13clL1P/tc-custom/9780253027986.jpg?1729082523831" alt="This image is the cover for the book Evolution of the American Diesel Locomotive, Railroads Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evolution of the American Diesel Locomotive, Railroads Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <b>“An important contribution to railroad technological history. The book’s strength is the author’s mastery of the mechanical details.” —Mark Reutter, editor, <i>Railroad History</i></b><br/><br/>The diesel locomotive sent shock waves through rigid corporate cultures and staid government regulators. For some, the new technology promised to be a source of enormous profits; for others, the railroad industry seemed a threat to their very livelihoods. <i>Evolution of the American Diesel Locomotive </i>introduces the reader to the important technological advances that gave rise to diesel engines, examining not only their impact on locomotive design, but also their impact on the economic and social landscapes. J. Parker Lamb describes the development of these technologies, allowing the reader to fully understand how they were integrated and formed a commercially successful locomotive. Like its companion volume, <i>Perfecting the American Steam Locomotive </i>(IUP, 2003), this book emphasizes the role of the leading engineers whose innovations paved the way for critical breakthroughs. Rail fans will appreciate this authoritative work.<br/><br/><b>“A host of books and articles have touched on various aspects of this ongoing story over the years, but none tell the story with the completeness and superb clarity found here.” —<i>Michigan Railfan</i></b><br/><br/><b>“Lamb provides the reader with detailed descriptions of every generation of diesel locomotive along with a generous supply of excellent photographs.” —<i>Technology and Culture</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Parker Lamb
      </h2>
      
      <p class="authorDescription body article"><P>J. Parker Lamb retired in 2001, after a 42-year career as a practicing engineer and university instructor, to pursue his life-long interest in the history of American technology with an emphasis on railroad developments. He has authored four books, including Perfecting the American Steam Locomotive (IUP, 2003). He lives in Austin, Texas.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e23b759